import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import { render } from "react-dom";
import CountUp from "react-countup";

class Explore extends Component {
  render() {
    return (
      <div className="stat-wrap">
        <section className="stat-section section-gap-half">
          <div className="container">
            <Row>
              <Col lg={4} md={4} sm={4} xs={6} className="text-center">
                <h2>Scalehighs</h2>
                <Row>
                  <Col lg={6} md={6} sm={6} xs={6}>
                    <div className="single-stat">
                      <i className="ti-thumb-up"></i>
                      <h1>
                        <CountUp
                          className="account-balance"
                          start={1000}
                          end={100000}
                          duration={5}
                          suffix="+"
                        />
                        {/* <span className="counter">100000</span>+ */}
                      </h1>
                      <h4>{this.props.loadTranslations("Members", this.props.currentLanguage)}</h4>
                    </div>
                  </Col>
                  <Col lg={6} md={6} sm={6} xs={6}>
                    <div className="single-stat">
                      <i className="ti-face-smile"></i>
                      <h1>
                        <CountUp
                          className="account-balance"
                          start={10}
                          end={1000}
                          duration={5}
                          suffix="+"
                        />
                        {/* <span className="counter">1000</span>+ */}
                      </h1>
                      <h4>{this.props.loadTranslations("Businesses", this.props.currentLanguage)}</h4>
                    </div>
                  </Col>
                  <Col lg={6} md={6} sm={6} xs={6}>
                    <div className="single-stat">
                      <i className="ti-paint-bucket"></i>
                      <h1>
                        <CountUp
                          className="account-balance"
                          start={10}
                          end={500}
                          duration={5}
                          suffix="+"
                        />
                        {/* <span className="counter">500</span>+ */}
                      </h1>
                      <h4>{this.props.loadTranslations("Projects", this.props.currentLanguage)}</h4>
                    </div>
                  </Col>
                  <Col lg={6} md={6} sm={6} xs={6}>
                    <div className="single-stat">
                      <i className="ti-check-box"></i>
                      <h1>
                        <CountUp
                          className="account-balance"
                          start={10}
                          end={10000}
                          duration={5}
                          suffix="+"
                        />
                        {/* <span className="counter">10000</span>+ */}
                      </h1>
                      <h4>{this.props.loadTranslations("Jobs", this.props.currentLanguage)}</h4>
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col lg={4} md={4} sm={4} xs={6} className="text-center" style={{ borderLeft: '1px solid #ffffff', borderRight: '1px solid #ffffff' }}>
                <h2>Easy Praxis</h2>
                <Row>
                  <Col lg={6} md={6} sm={6} xs={6}>
                    <div className="single-stat">
                      <i className="ti-thumb-up"></i>
                      <h1>
                        <CountUp
                          className="account-balance"
                          start={1000}
                          end={100000}
                          duration={5}
                          suffix="+"
                        />
                        {/* <span className="counter">100000</span>+ */}
                      </h1>
                      <h4>{this.props.loadTranslations("Patients", this.props.currentLanguage)}</h4>
                    </div>
                  </Col>
                  <Col lg={6} md={6} sm={6} xs={6}>
                    <div className="single-stat">
                      <i className="ti-face-smile"></i>
                      <h1>
                        <CountUp
                          className="account-balance"
                          start={10}
                          end={1000}
                          duration={5}
                          suffix="+"
                        />
                        {/* <span className="counter">1000</span>+ */}
                      </h1>
                      <h4>{this.props.loadTranslations("Doctors", this.props.currentLanguage)}</h4>
                    </div>
                  </Col>
                  <Col lg={6} md={6} sm={6} xs={6}>
                    <div className="single-stat">
                      <i className="ti-paint-bucket"></i>
                      <h1>
                        <CountUp
                          className="account-balance"
                          start={10}
                          end={500}
                          duration={5}
                          suffix="+"
                        />
                        {/* <span className="counter">500</span>+ */}
                      </h1>
                      <h4>{this.props.loadTranslations("Orders", this.props.currentLanguage)}</h4>
                    </div>
                  </Col>
                  <Col lg={6} md={6} sm={6} xs={6}>
                    <div className="single-stat">
                      <i className="ti-check-box"></i>
                      <h1>
                        <CountUp
                          className="account-balance"
                          start={10}
                          end={10000}
                          duration={5}
                          suffix="+"
                        />
                        {/* <span className="counter">10000</span>+ */}
                      </h1>
                      <h4>{this.props.loadTranslations("Medicines", this.props.currentLanguage)}</h4>
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col lg={4} md={4} sm={4} xs={6} className="text-center">
                <h2>{this.props.loadTranslations("IT Services", this.props.currentLanguage)} </h2>
                <Row>
                  <Col lg={6} md={6} sm={6} xs={6}>
                    <div className="single-stat">
                      <i className="ti-thumb-up"></i>
                      <h1>
                        <CountUp
                          className="account-balance"
                          start={1000}
                          end={100000}
                          duration={5}
                          suffix="+"
                        />
                        {/* <span className="counter">100000</span>+ */}
                      </h1>
                      <h4>{this.props.loadTranslations("Customers", this.props.currentLanguage)}</h4>
                    </div>
                  </Col>
                  <Col lg={6} md={6} sm={6} xs={6}>
                    <div className="single-stat">
                      <i className="ti-face-smile"></i>
                      <h1>
                        <CountUp
                          className="account-balance"
                          start={10}
                          end={1000}
                          duration={5}
                          suffix="+"
                        />
                        {/* <span className="counter">1000</span>+ */}
                      </h1>
                      <h4>{this.props.loadTranslations("Digitalisation", this.props.currentLanguage)} </h4>
                    </div>
                  </Col>
                  <Col lg={6} md={6} sm={6} xs={6}>
                    <div className="single-stat">
                      <i className="ti-paint-bucket"></i>
                      <h1>
                        <CountUp
                          className="account-balance"
                          start={10}
                          end={500}
                          duration={5}
                          suffix="+"
                        />
                        {/* <span className="counter">500</span>+ */}
                      </h1>
                      <h4>{this.props.loadTranslations("Projects", this.props.currentLanguage)}</h4>
                    </div>
                  </Col>
                  <Col lg={6} md={6} sm={6} xs={6}>
                    <div className="single-stat">
                      <i className="ti-check-box"></i>
                      <h1>
                        <CountUp
                          className="account-balance"
                          start={10}
                          end={10000}
                          duration={5}
                          suffix="+"
                        />
                        {/* <span className="counter">10000</span>+ */}
                      </h1>
                      <h4>{this.props.loadTranslations("IT Resources", this.props.currentLanguage)} </h4>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </section>
      </div>
    );
  }
}

export default Explore;



// WEBPACK FOOTER //
// ./screens/MainPage/Explore.js